import React, {Component, Fragment} from "react";
import {Col, Progress, Row} from "reactstrap";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Text, Tooltip, XAxis, YAxis} from "recharts";
import cn from "classnames";
import queryString from "querystring";
import APIClient from "../../../components/ApolloClientComponent/ApolloClient";
import gql from "graphql-tag";
import Fire from "../../../components/firebase/Fire";
import LineContainer from "../../../components/lineContainer/LineContainer";
import {LoadingLogo} from "../../../components/loading/loading-logo";

class CustomizedAxisTick extends Component {
	render() {
		const {x, y, payload} = this.props;
		return <Text x={x} y={y} width={50} textAnchor="middle" verticalAnchor="start">{payload.value}</Text>;
	}
}


class Report extends Component {
	constructor(props) {
		super(props);
		const query = queryString.decode(props.location.search.replace("?", ""));

		this.state = {
			applicationId: query.applicationId,
			firstName: "Name Goes Here",
			lastName: "",
			phoneNumber: "########",
			email: "email@emailprovider.com",
			nationality: "",
			jobStatus: "Currently Employed",
			aboutDesc: "No about provided or resume has not been uploaded", //"Lorem ipsum bacon, spicy tortilla. Chips for dinner? That sounds amazing! I am so good at being a software engineer.",
			address: "Al-Farwaniya, Kuwait",
			education: "",
			workExperience: "",
			//Information about the rest of the candidates:
			totalCandidates: 100,
			//Information that  AIVA produced about the candidate:
			rank: 10,
			qualified: true, // Indicates whether or not the candidate has passed the mandatory questions.
			fitnessCriteria: [],
			manQs: [],
			tbQs: [],
			isLoading: true
		};

		this.loadApplication = this.loadApplication.bind(this);
		this.loadRank = this.loadRank.bind(this);
	}

	componentDidMount() {
		this.loadApplication();
		this.loadRank();
	}

	loadRank() {
		const query = gql`
			query rank($appId: ID!) {
				rank(applicationId: $appId) {
					applicants
					rank
				}
			}
		`;
		APIClient.query({
			fetchPolicy: "no-cache",
			query,
			variables: {
				appId: this.state.applicationId
			}
		})
			.then(result => {
				if (result.data) {
					this.setState({
						totalCandidates: result.data.rank.applicants,
						rank: result.data.rank.rank
					});
				}
			});
	}

	loadApplication() {
		const queryGrades = gql`
			query grades($appId: ID!) {
				applicationReport(applicationId: $appId) {
					grade
					skill
				}
				application(id: $appId) {
					id
					job {
						id
					}
					user {
						id
					}
				}
			}
		`;
		APIClient.query({
			fetchPolicy: "no-cache",
			query: queryGrades,
			variables: {
				appId: this.state.applicationId
			}
		}).then((result) => {
			const jobId = result.data.application.job.id;
			const userId = result.data.application.user.id;
			Fire.database().ref(`parsedResumes/${jobId}/${userId}/parts`).once("value").then(snapshot => {
				const resume = snapshot.val();
				if (resume) {
					this.setState({
						education: resume.education ? resume.education : "",
						workExperience: resume.experience ? resume.experience : "",
						aboutDesc: resume.summary ? resume.summary : this.state.aboutDesc
					});
				}
			});
			const fitness = result.data.applicationReport.map((i) => {
				return {criterion: i.skill, gradeAchieved: i.grade};
			});

			const fitnessMap = new Map();
			fitness.forEach(element => {
				if (fitnessMap.has(element.criterion)) {
					fitnessMap.get(element.criterion).gradeAchieved += element.gradeAchieved;
					fitnessMap.get(element.criterion).counter += 1;
				} else {
					fitnessMap.set(element.criterion, {gradeAchieved: element.gradeAchieved, counter: 1});
				}
			});
			this.setState({
				fitnessCriteria: fitnessMap
			});
		});

		const queryApplication = gql`
			query application($appId: ID!) {
				application(id: $appId) {
					user {
						firstName
						lastName
						email
						phone
					}
					status
					resume
					answers {
						question {
							mandatory
							question
							answers {
								answerString
							}
						}
						message
					}
					passedMan
				}
			}
		`;
		APIClient.query({
			fetchPolicy: "no-cache",
			query: queryApplication,
			variables: {
				appId: this.state.applicationId
			}
		}).then((result) => {
			const natQ = result.data.application.answers.filter((ans) =>
				ans.question.question.includes("nationality")
			);

			const nationality = natQ[0] ? natQ[0].message : "";

			const manQuestions = [];
			const techAndBehavioralQuestions = [];

			result.data.application.answers.forEach((element) => {
				
				if(element.question.mandatory) {
					manQuestions.push(element);
				}	else {
					techAndBehavioralQuestions.push(element);
				}
			});

			if (result.data.application.user) {
				const user = result.data.application.user;
				this.setState({
					firstName: user.firstName,
					lastName: user.lastName,
					phoneNumber: user.phone,
					email: user.email,
					nationality: nationality,
					qualified: result.data.application.passedMan,
					manQs: manQuestions,
					tbQs:techAndBehavioralQuestions,
					isLoading: false
				});
			}
		}).catch(err => console.log(err));
	}

	fitnessCriteriaBars(fitnessCriteriaArray) {
		let elements = [];
		let barchartData = [];
		let totalGrades = 0;

		fitnessCriteriaArray.forEach((criterion, key) => {
			let grade = ((criterion.gradeAchieved * 100) / criterion.counter).toFixed(2);
			let color; //"#"+(Math.random()*0xFFFFFF<<0).toString(16);
			let icon;
			if (grade > 90) {
				color = "success";
				icon = "fa fa-star ";
			} else if (grade > 75) {
				color = "info";
				icon = "fa fa-star-half-empty ";
			} else if (grade > 50) {
				color = "warning";
				icon = "fa fa-star-o fa-lg ";
			} else {
				color = "danger";
				icon = "fa fa-times-circle-o ";
			}

			barchartData.push({
				name: key,
				Candidate: parseInt(grade, 10)
			});
			totalGrades += parseInt(grade, 10);

			elements.push(
				<div className="col-6">
					<div key={key} className="progress-group" style={{flex: 1}}>
						<div className="progress-group-header">
							<i className={icon + "progress-group-icon"} />
							<span className="criterion-title">
								<span className="d-block">{key}</span>
								<sub style={{color: "#808080b3"}}> {criterion.counter} questions asked</sub></span>
							<span className="ml-auto criterion-title">{grade + "%"}</span>
						</div>
						<div className="progress-group-bars">
							<Progress className="progress-xs" color={color} value={grade} />
						</div>
					</div>
				</div>
			);
		});

		barchartData.push({
			name: "Avg Grade",
			Candidate: (totalGrades / fitnessCriteriaArray.size).toFixed(2)
		});

		return (
			<Fragment>
				<div className="row">{elements}</div>
				<Row>
					<Col xs={"12"} md={"12"}>
						<ResponsiveContainer className={"hide-print"} width={"100%"} height={250}>
							<BarChart data={barchartData}>
								<CartesianGrid strokeDasharray={"3 3"}/>
								<XAxis height={40} tick={<CustomizedAxisTick/>} dataKey={"name"} interval={0}/>
								<YAxis type={"number"}/>
								<Tooltip/>
								<Legend/>
								<Bar dataKey={"Candidate"} fill={"#20a8d8"}/>
								{/*<Bar dataKey={""}/>*/}
							</BarChart>
						</ResponsiveContainer>
						<BarChart className={"show-print"} data={barchartData} width={860} height={250}>
							<CartesianGrid strokeDasharray={"3 3"} />
							<XAxis height={40} tick={<CustomizedAxisTick/>} dataKey={"name"} interval={0}/>
							<YAxis type={"number"} />
							<Tooltip />
							<Legend />
							<Bar dataKey={"Candidate"} fill={"#20a8d8"} />
							{/*<Bar dataKey={""}/>*/}
						</BarChart>
					</Col>
				</Row>
			</Fragment>
		);
	}

	basicInfoRow(elementName, elementValue) {
		return (
			<Row
				style={{marginLeft: "0px", marginRight: "0px"}}
				className="basic-info-row"
			>
				<Col sm="5" md="5" style={{ alignContent: "start" }}>
					<h6 className="report-subheader">{elementName}:</h6>
				</Col>
				<Col sm="7" md="7" style={{ alignContent: "start" }}>
					<p className="report-content">{elementValue}</p>
				</Col>
			</Row>
		);
	}

	questionsRow(element) {
		return (
			<li>
				<h6 className={"report-content"}>{element.question.question}</h6>
				<p className={"report-subheader"} >
					{element.message}
				</p>
			</li>
		);
	}

	prepareWorkExperience() {
		let exp = [];

		// this.state.workExperience.forEach((element) => {
		// 	let extraArr = [];
		//
		// 	element.extra.forEach((extra) => {
		// 		extraArr.push(<li className={"report-content"}>{extra}</li>);
		// 	});
		//
		// 	exp.push(
		// 		<li>
		// 			<h6 className={"report-subheader"}>{element.jobtitle}</h6>
		// 			<i className={"report-content"}>
		// 				{element.company}, {element.from}-{element.to}
		// 			</i>
		// 			<ul>{extraArr}</ul>
		// 		</li>
		// 	);
		// });

		if (this.state.workExperience.length === 0) {
			exp.push(
				<li key={"no-exo"}>
					<i className={"report-content"}>
						No work experience has been found. Please ask candidate to update
						their resume.
					</i>
				</li>
			);
		} else {
			exp.push(this.state.workExperience.split("\n").map(a => a.trim()).filter(a => !a.endsWith(":")).map((w, index) => (
				<li key={index}>{w}</li>)));
		}

		return (
			<LineContainer lineContainerLabel={"Work Experience"} style={{height: "100%"}}>
				<ul>{exp}</ul>
			</LineContainer>
		);
	}

	prepareEducation() {
		let edc = [];

		// this.state.education.forEach((element) => {
		// 	let extraArr = [];
		//
		// 	extraArr.push(<li className={"report-content"}>GPA: {element.gpa}</li>);
		//
		// 	element.extra.forEach((extra) => {
		// 		extraArr.push(<li className={"report-content"}>{extra}</li>);
		// 	});
		//
		// 	edc.push(
		// 		<li>
		// 			<h6 className={"report-subheader"}>
		// 				{element.degree ? element.degree + ", " + element.major : element.major}
		// 			</h6>
		// 			<i className={"report-content"}>
		// 				{element.institution}, {element.yearFrom}-{element.yearTo}
		// 			</i>
		// 			<ul>{extraArr}</ul>
		// 		</li>
		// 	);
		// });
		if (this.state.education.length === 0) {
			edc.push(
				<li key="no-exp">
					<i className={"report-content"}>
						Education records have not been found. Please ask candidate to
						update their resume.
					</i>
				</li>
			);
		} else {
			edc.push(this.state.education.split("\n").map(a => a.trim()).filter(a => !a.endsWith(":")).map((i, index) => (
				<li key={index}>{i}</li>)));
		}

		return (
			<LineContainer lineContainerLabel={"Education"} style={{height: "100%"}}>
				<ul>{edc}</ul>
			</LineContainer>
		);
	}

	render() {
		if (this.state.isLoading) {
			return (
				<LoadingLogo style={{height: "100%",}}/>
			);
		}
		let icon = this.state.qualified ? "icon-check" : "icon-close";
		return (
			<div className="report-card">
				<div id="name">
					<h2>{this.state.firstName + " " + this.state.lastName}</h2>
					<div style={{display: "flex", flexWrap: "nowrap"}}>
						<h5 className={"report-header"}>Passed Mandatory: </h5>
						<i
							style={{marginLeft: "0.5rem"}}
							className={icon + " icons font-xl"}
						/>
					</div>
				</div>

				<LineContainer lineContainerLabel="About">
					<div
						style={{
							display: "flex",
							flexWrap: "nowrap",
							alignItems: "center",
							alignContent: "center"
						}}
					>
						<Col className={cn({hide: this.state.aboutDesc === ""})}>
							<p className="report-content">{this.state.aboutDesc}</p>
						</Col>
						<div
							style={{
								borderLeft: "1px solid rgba(44, 62, 80, 0.5)",
								height: "100px",
								marginLeft: "5px",
								marginRight: "5px"
							}}
						/>
						<Col style={{maxWidth: "40%"}}>
							<Row style={{marginLeft: "0px", marginRight: "0px"}}>
								<h5 className="report-header" style={{alignSelf: "start"}}>
									Basic Information
								</h5>
							</Row>
							{this.basicInfoRow("nationality", this.state.nationality)}
							{this.basicInfoRow("email", this.state.email)}
							{this.basicInfoRow("phone", this.state.phoneNumber)}
							{this.basicInfoRow("address", this.state.address)}
							{this.basicInfoRow("employment", this.state.jobStatus)}
						</Col>
					</div>
				</LineContainer>

				<div
					style={{
						display: "grid",
						gridTemplateColumns: "50% 50%",
						marginBottom: "32px"
					}}
				>
					<div
						style={{
							margin: "16px 16px 16px 0",
							height: "100%"
						}}
					>
						{this.prepareWorkExperience()}
					</div>
					<div
						style={{
							margin: "16px 0 16px 0",
							height: "100%"
						}}
					>
						{this.prepareEducation()}
					</div>
				</div>

				<LineContainer className={"no-break break-after"} lineContainerLabel="Candidate Fitness">
					<h5
						style={{marginBottom: "0.5rem", paddingLeft: "15px"}}
						className={"report-subheader"}
					>
						Rank: {this.state.rank}{" "}
						<sub style={{color: "rgba(32, 160, 186, 0.75)"}}>
							/{this.state.totalCandidates}
						</sub>
					</h5>
					{this.fitnessCriteriaBars(this.state.fitnessCriteria)}
				</LineContainer>

				<LineContainer className={"break-before"} lineContainerLabel={"Mandatory Info Questions"}>
					<ul>
						{this.state.manQs.map(e => this.questionsRow(e))}
					</ul>
				</LineContainer>

				<LineContainer lineContainerLabel={"Technical & Behavioral Questions"}>
					<ul>
						{this.state.tbQs.map(e => this.questionsRow(e))}
					</ul>
				</LineContainer>

				<div id={"report-footer"}>
					<h5 className={"report-subheader"}> Report Generated by AIVA</h5>
					<i className={"report-content"}>
						Use of AIVA and produced content is subject to license agreement
						with TalentScript
					</i>
				</div>
			</div>
		);
	}
}

export default Report;
